import { IMAGES } from 'src/assets'
import { LiveIcon } from 'src/components/svgIcon'
import { PostLiveProps } from './postLive.types'
import { Image, LiveBadge, Wrapper } from './postLive.styles'

const PostLive = ({ post, aspectRatio }: PostLiveProps) => {
  const handleError = ({ currentTarget }) => {
    currentTarget.onerror = null
    currentTarget.src = IMAGES.LIVE_POST_IMG
    currentTarget.style.width = '100%'
    currentTarget.style.height = '100%'
  }

  return (
    <Wrapper className="_bg-gray-100" $aspectRatio={aspectRatio}>
      <LiveBadge className="_d-flex _align-items-center _justify-content-center _bg-white _text-red _rounded-lg _position-absolute">
        <LiveIcon />
        <span className="_text-uppercase _font-weight-bold _ml-3">Live</span>
      </LiveBadge>

      <Image
        src={post.live?.thumbnail || IMAGES.LIVE_POST_IMG}
        alt={post.title}
        loading="lazy"
        fullWidth={!post.live?.thumbnail}
        onError={handleError}
      />
    </Wrapper>
  )
}

export default PostLive
